module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10053.63f61c10.jpg";